/**
 * Created by ganlu on 18/10/2016.
 */
class FooterController {
    constructor(AppConfig,$window) {
        "ngInject";
        this.AppConfig = AppConfig;
        this.$window=$window;
    }
}

export default FooterController;



// WEBPACK FOOTER //
// ./src/app/common/yb-small-footer/ybfooter.controller.js